import styled from '@emotion/styled'
import {
    Grid,
    Card,
    Divider,
    Container,
    CardContent,
    Dialog,
    DialogTitle,
    InputBase,
    InputLabel,
    FormControl,
    IconButton
} from "@mui/material";
import { Close } from '@mui/icons-material';


function OultetInfoDrawer({
    visible,
    outletdata,
    closeText,
    onClose,
    title
}) {

    // const drawerStyles = DrawerStyles();
    if (outletdata == undefined) outletdata = {
        name: '',
        gstn: '',
        contact_number: '',
        fax: '',
        address: '',
        city: '',
        pincode: '',
        state: '',
        country: '',
        address: ''
    }
    if (outletdata.address == undefined)
        outletdata.address = ""
    if (outletdata.fax == undefined)
        outletdata.fax = ""

    if (outletdata.gstn == undefined) {
        outletdata.gstn = ""
    }

    const BootstrapInput = styled(InputBase)(({ theme }) => ({
        "label + &": {
            marginTop: theme.spacing(6)
        },
        "& .MuiInputBase-input": {
            borderRadius: 10,
            position: "relative",
            backgroundColor: "gray[100]",
            border: "1px solid #ced4da",
            fontSize: 16,
            width: "auto",
            padding: "10px 12px",
            transition: theme.transitions.create([
                "border-color",
                "background-color",
                "box-shadow"
            ]),
            fontWeight: "bold",
        }
    }));

    return (
        <div>
            <Dialog
                maxWidth="sm"
                fullWidth
                open={visible}
            >
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }}>
                    <Divider />
                    <Card>
                        <CardContent>
                            <Grid container spacing={6} sx={{ paddingBottom: 3 }}>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            Name
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.name}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            Contact Number
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.contact_number}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container spacing={6} sx={{ paddingBottom: 3 }}>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            GSTN
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.gstn === '' ? "-" : outletdata?.gstn}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            Fax
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.fax === '' ? "-" : outletdata?.fax}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container sx={{ paddingBottom: 3 }}>
                                <Grid item >
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            Address
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.address === '' ? "-" : outletdata?.address}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container spacing={6} sx={{ paddingBottom: 3 }}>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            City
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.city}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            Pincode
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.pincode}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container spacing={6} sx={{ paddingBottom: 3 }}>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            State
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.state}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <FormControl variant="standard">
                                        <InputLabel shrink htmlFor="bootstrap-input" variant='filled'>
                                            Country
                                        </InputLabel>
                                        <BootstrapInput
                                            defaultValue={outletdata?.country}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>


                        </CardContent>
                    </Card>
                </Container>
            </Dialog>
        </div >
    )
}

export default OultetInfoDrawer